import { render, staticRenderFns } from "./VaModal.vue?vue&type=template&id=6017505c&"
import script from "./VaModal.vue?vue&type=script&lang=js&"
export * from "./VaModal.vue?vue&type=script&lang=js&"
import style0 from "./VaModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports